import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import { useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import { useEffect, useState } from "react";

const Nav = ({ loggedIn, setLoggedIn }) => {
  const navigate = useNavigate();

  useEffect(() => {
    setLoggedIn(localStorage.getItem("token"));
  }, []);

  const logOut = (e) => {
    e.preventDefault();
    localStorage.removeItem("token");
    setLoggedIn("");
    navigate("/");
  };
  return (
    <Navbar className="bg-body-tertiary">
      <Container>
        <Navbar.Brand href="/">SimpleBooks</Navbar.Brand>
        <Navbar.Toggle />
        <Navbar.Collapse className="justify-content-end">
          {loggedIn && loggedIn.length > 0 ? (
            <Button onClick={logOut} type="submit">
              Log Out
            </Button>
          ) : (
            ""
          )}
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Nav;
